import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import DataGridForm from "../../../../components/common/DataGridForm";
import {
  AlertConfirmDeleteAll,
  AlertSuccess,
} from "../../../../components/alert";
import ModalBloqueInformacionUtil from "./ModalBloqueInformacionUtil";

const getBloqueLabel = (bloque, index) => {
  if (bloque.titulo?.trim()) {
    return bloque.titulo;
  }

  const itemsCount = bloque.items?.length || 0;
  return `Bloque ${index + 1} (${itemsCount} registro${itemsCount !== 1 ? "s" : ""})`;
};

const BloquesInformacionUtil = ({ bloques, setBloques }) => {
  const [showModalBloque, setShowModalBloque] = React.useState(false);
  const [bloqueActivo, setBloqueActivo] = React.useState(null);
  const [isNewBlock, setIsNewBlock] = React.useState(false);

  const bloquesParaLista = bloques.map((bloque, index) => ({
    ...bloque,
    tituloLista: getBloqueLabel(bloque, index),
  }));

  const handleOpenNewBloque = () => {
    const nuevoBloque = {
      id: Math.floor(Math.random() * 100000),
      titulo: `Bloque ${bloques.length + 1}`,
      items: [],
      isNew: true,
    };
    setBloqueActivo(nuevoBloque);
    setIsNewBlock(true);
    setShowModalBloque(true);
  };

  const handleEditBloque = (data) => {
    setBloqueActivo({ ...data });
    setIsNewBlock(false);
    setShowModalBloque(true);
  };

  const handleDeleteBloque = (id) => {
    AlertConfirmDeleteAll(
      "",
      "warning",
      async (response) => {
        if (response.isConfirmed) {
          setBloques(bloques.filter((bloque) => bloque.id !== id));
          AlertSuccess("Bloque eliminado con éxito");
        }
      },
      "¡Atención!",
      "Continuar",
      "Cancelar",
      true,
      '<div class="swal2-html-container">Estás por eliminar el bloque y todos sus registros. <br><br> ¿Querés continuar?</div>'
    );
  };

  const handleSaveBloque = (bloqueActualizado) => {
    if (isNewBlock) {
      setBloques([...bloques, bloqueActualizado]);
    } else {
      setBloques(
        bloques.map((bloque) =>
          bloque.id === bloqueActualizado.id ? bloqueActualizado : bloque
        )
      );
    }
  };

  const onReorderBloques = (e) => {
    const visibleRows = e.component.getVisibleRows();
    const orderedIds = visibleRows.map((row) => row.data.id);
    const newData = orderedIds
      .map((id) => bloques.find((bloque) => bloque.id === id))
      .filter(Boolean);

    setBloques(newData);
  };

  const AccionBloque = (data) => (
    <>
      <button
        type="button"
        className="btn btn-sm btn btn-success"
        onClick={() => handleEditBloque(data)}
      >
        <i className="fa fa-pencil" />
      </button>{" "}
      <button
        type="button"
        className="btn btn-sm btn btn-danger"
        onClick={() => handleDeleteBloque(data.id)}
      >
        <i className="fa fa-trash" />
      </button>
    </>
  );

  return (
    <>
      <Row>
        <Col>
          <Form.Group>
            <label>Bloques de información</label>
            {bloques.length > 0 ? (
              <DataGridForm
                dataSource={bloquesParaLista}
                keyExpr="id"
                allowReordering={true}
                onReorder={onReorderBloques}
                columnHidingEnabled={true}
                columns={[
                  {
                    caption: "Bloque",
                    dataField: "tituloLista",
                  },
                  {
                    caption: "Acciones",
                    alignment: "center",
                    render: "AccionBloque",
                    cellRender: { AccionBloque },
                    hidingPriority: 0,
                  },
                ]}
              />
            ) : (
              <h5>
                Aún no se encuentran bloques. Para iniciar haga click en
                &quot;Añadir bloque&quot;.
              </h5>
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleOpenNewBloque}
          >
            Añadir bloque
          </button>
        </Col>
      </Row>

      <ModalBloqueInformacionUtil
        showModal={showModalBloque}
        setShowModal={setShowModalBloque}
        bloque={bloqueActivo}
        onSave={handleSaveBloque}
        isNewBlock={isNewBlock}
      />
    </>
  );
};

export default BloquesInformacionUtil;